export function catalogMatchRank(
  item: { sku: string; name: string; merchant_sku?: string | null; barcode?: string | null },
  term: string,
): number | null {
  const query = term.trim().toLowerCase();
  if (!query) return null;
  const merchantSku = item.merchant_sku?.toLowerCase() ?? "";
  const sku = item.sku.toLowerCase();
  const name = item.name.toLowerCase();
  const barcode = item.barcode?.toLowerCase() ?? "";
  const starlessQuery = query.replace(/^\*+/, "");
  if (merchantSku === query || (starlessQuery && merchantSku.replace(/^\*+/, "") === starlessQuery)) return 0;
  if (sku === query || barcode === query) return 1;
  if ([merchantSku, sku, name].some((value) => value.startsWith(query))) return 2;
  if ([merchantSku, sku, name, barcode].some((value) => value.includes(query))) return 3;
  return null;
}

type KatalogArtikel = Parameters<typeof catalogMatchRank>[0] & { folder_id?: number | null };

// Treffer ueber den ganzen Katalog: nach Rang, Artikel aus „Gelöscht“ stets am Ende.
export function katalogTreffer<T extends KatalogArtikel>(
  items: T[],
  term: string,
  geloeschtIds: Set<number>,
  limit: number,
): { item: T; geloescht: boolean }[] {
  if (!term.trim()) return [];
  return items
    .map((item) => ({
      item,
      rank: catalogMatchRank(item, term),
      geloescht: item.folder_id != null && geloeschtIds.has(item.folder_id),
    }))
    .filter((t): t is { item: T; rank: number; geloescht: boolean } => t.rank !== null)
    .sort((a, b) => Number(a.geloescht) - Number(b.geloescht) || a.rank - b.rank)
    .slice(0, limit)
    .map(({ item, geloescht }) => ({ item, geloescht }));
}
